// Active tab on load
window.addEventListener('load', () => {
  const tabsModule = document.querySelector('.tabs-module');
  if (!tabsModule) return;

  const filteredTypes = new URLSearchParams(window.location.search).get('filteredTypes');
  if (!filteredTypes) return;

  const targetTab = tabsModule.querySelector(`[data-tab-id="${filteredTypes}"]`);
  if (!targetTab) return;

  tabsModule.querySelector('.tabs-slider__tab.is-active')?.classList.remove('is-active');
  targetTab.classList.add('is-active');
});
